package ru.villawonka.app.presentation.screens.search.compose.view

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.expandVertically
import androidx.compose.animation.shrinkVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.common.extensions.isScrollingUp
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.screens.search.model.SortTypeUIModel
import ru.villawonka.app.resources.AppResources

@Composable
fun TopBarView(
    modifier: Modifier = Modifier,
    onSearchFilterClick: () -> Unit,
    onSearchSortClick: () -> Unit,
    sortType: SortTypeUIModel,
    hasCustomFilters: Boolean,
    listState: LazyListState,
) {
    val isNeedTopBarShow = listState.isScrollingUp() || listState.firstVisibleItemIndex <= 2
    val enterTransition = expandVertically(animationSpec = tween(300, 0))
    val exitTransition = shrinkVertically(animationSpec = tween(300, 0))

    AnimatedVisibility(
        visible = isNeedTopBarShow,
        enter = enterTransition,
        exit = exitTransition
    ) {
        Row(
            modifier = modifier
                .fillMaxWidth()
                .background(
                    color = MaterialTheme.colors.surfaceMiddle,
                    shape = RoundedCornerShape(
                        bottomStart = 24.dp,
                        bottomEnd = 24.dp,
                    )
                )
                .padding(
                    horizontal = 16.dp,
                    vertical = 12.dp,
                ),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            FilterButton(
                text = AppResources.strings.topBarItemFilter,
                hasFilters = hasCustomFilters
            ) {
                onSearchFilterClick.invoke()
            }
            SortButton(sortType = sortType) {
                onSearchSortClick.invoke()
            }
        }
    }
}